import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { createSelector, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { validString } from 'src/app/shared/utilities/types.utils';
import { selectParentHostName, selectTenantName } from '../../client-configuration/client-configuration.selectors';
import { selectIpAddress } from '../../environment/environment.selectors';
import { selectGatewaySessionToken } from '../../gateway-session-token/gateway-session-token.selectors';
import { selectHostAppName } from '../../parent-config/parent-config.selectors';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  tenantName: string;
  hostname: string;
  hostAppName: string;
  ipAddress: string;
  gatewaySessionToken: string;

  constructor(private store: Store<AppState>) {
    this.store
      .select(selectTenantName)
      .pipe(filter(validString), take(1))
      .subscribe((tenantName) => {
        this.tenantName = tenantName;
      });
    this.store
      .select(
        createSelector(
          selectParentHostName,
          selectHostAppName,
          selectIpAddress,
          selectGatewaySessionToken,
          (parentHostName, hostAppName, ipAddress, gatewaySessionToken) => ({
            parentHostName,
            hostAppName,
            ipAddress,
            gatewaySessionToken,
          })
        )
      )
      .subscribe(({ parentHostName, hostAppName, ipAddress, gatewaySessionToken }) => {
        this.hostname = validString(parentHostName) ? parentHostName : '';
        this.hostAppName = validString(hostAppName) ? hostAppName : '';
        this.ipAddress = ipAddress;
        this.gatewaySessionToken = gatewaySessionToken;
      });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers: Record<string, string> = {
      'com-accessopassport-client': this.tenantName || '',
      'source-domain': this.hostname || '',
      'source-app': this.hostAppName || 'AccessoPay',
      'source-ip': this.ipAddress || '',
      Accept: 'application/json',
      ...req.headers.keys().reduce((acc, curr) => {
        acc[curr] = req.headers.get(curr);
        return acc;
      }, {}),
    };

    if (this.gatewaySessionToken) {
      headers.Authorization = `Bearer ${this.gatewaySessionToken}`;
    }

    return next.handle(req.clone({ setHeaders: headers }));
  }
}
